function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLight353X353Px = function SvgLight353X353Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 353 353",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M198.7 6.3 345 161.2c9.4 10 9 25.7-1 35.1L189.1 342.6c-10 9.4-25.7 9-35.1-1L7.6 186.7c-9.4-10-9-25.7 1-35.1L163.5 5.3c10-9.5 25.7-9 35.2 1",
    style: {
      fill: "#f0f4f9"
    }
  }));
};
export default SvgLight353X353Px;